import { useEffect, useMemo, useRef } from "react";
//#region src/SearchBar/useDebouncedCallback.ts
function useDebouncedCallback(callback, delay) {
	const callbackRef = useRef(callback);
	callbackRef.current = callback;
	const timeoutRef = useRef(void 0);
	const debounced = useMemo(() => {
		const fn = (...args) => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => {
				callbackRef.current(...args);
			}, delay);
		};
		return fn;
	}, [delay]);
	useEffect(() => () => {
		if (timeoutRef.current) clearTimeout(timeoutRef.current);
	}, [debounced]);
	return debounced;
}
//#endregion
export { useDebouncedCallback };

//# sourceMappingURL=useDebouncedCallback.js.map